<template>
  <owa-modal-frame
    title="Enable Auto Renew?"
    has-actions
    :is-showing="isShowing"
    @close-modal="$emit('close-modal')"
  >
    <p>
      Stop worrying about dates and expirations! Turn on auto-renew to continue to get access to all of the icons, features, and services your subscription
      provides
      <strong>every year</strong>
      including&hellip;
    </p>

    <owa-subscription-features />

    <p class="message info with-icon margin-bottom-0">
      <font-awesome-icon
        :icon="$v7.regular.faStarShooting"
        size="lg"
        class="decorative fa-rotate-180"
      />
      <span>
        You'll be charged automatically on
        <strong>{{ periodEndAtDate }}</strong>
      </span>
    </p>

    <ul
      slot="actions"
      class="display-flex flex-column flex-items-center tablet:flex-row tablet:flex-content-between tablet:flex-row-reverse"
      style="--list-style-type: none; --list-padding-left: 0; --button-margin-bottom: 0; gap: var(--spacing-md)"
    >
      <li>
        <owa-action-button
          v-if="subscription.cancelAtPeriodEndAllowed"
          :is-processing="isProcessing"
          icon-name="faArrowsRotate"
          is-processing-label="Setting Up Auto-Renew..."
          label="Enable Auto-Renew"
          theme="success"
          @click="setupAutoRenewal"
        />
      </li>

      <li>
        <button
          type="button"
          class="flat"
          @click="$emit('close-modal')"
        >
          Cancel
        </button>
      </li>
    </ul>
  </owa-modal-frame>
</template>

<script>
  import { mapActions } from 'vuex'
  import moment from 'moment'
  import { ModalFrameMixin } from 'app/components-wa/modals/ModalFrame'

  export default {
    name: 'ModalAutoRenew',

    mixins: [ModalFrameMixin],

    props: {
      subscription: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        isProcessing: false
      }
    },

    computed: {
      periodEndAtDate() {
        return moment.utc(this.subscription.periodEndAt).format('MMMM D, YYYY')
      }
    },

    methods: {
      ...mapActions('flashMessages', ['addFlashMessage']),

      ...mapActions('subscriptions', ['cancelAtPeriodEnd']),

      async setupAutoRenewal() {
        this.isProcessing = true

        try {
          await this.cancelAtPeriodEnd(false)

          this.addFlashMessage({
            message: {
              content: `Your subscription has been set to auto-renew on ${this.periodEndAtDate}. You'll continue to get all of the updates, icons, and services included in your pro-level plan without interruption.`,
              iconName: 'faCheck',
              theme: 'success',
              styleOverride: { '--message-background': 'var(--green1);' }
            },
            topic: 'details:section'
          })
        } catch (err) {
          this.flashError()
        }

        this.isProcessing = false
        this.$emit('close-modal')
      },

      flashError() {
        this.addFlashMessage({
          message: {
            content: 'Ut oh! Something went wrong.',
            theme: 'danger',
            iconName: 'faSkullCrossbones',
            getHelp: true
          }
        })
      }
    }
  }
</script>
